module.exports = __webpack_public_path__ + "static/media/Methodology_front.37a9de08.jpg";